import { useMutation, type MutationHookOptions } from "@apollo/client"
import mutation from "@/v2-backoffice-client/invitation/remove/invitation.remove.mutation.gql"
import type {
  InvitationRemoveMutation,
  InvitationRemoveMutationVariables,
} from "@/v2-backoffice-client/invitation/remove/__types__/invitation.remove.mutation"

type Options = MutationHookOptions<
  InvitationRemoveMutation,
  InvitationRemoveMutationVariables
>

export function useInvitationRemoveMutation(options?: Options) {
  return useMutation<
    InvitationRemoveMutation,
    InvitationRemoveMutationVariables
  >(mutation, options)
}
